import React from 'react';

const BudgetAnalysisReport = React.lazy(() => import('../pages/BudgetAnalysisReport'));
const BudgetDetailReport = React.lazy(() => import('../pages/BudgetDetailReport'));
const BudgetSubItemMaintenance = React.lazy(() => import('../pages/BudgetSubItemMaintenance'));
const BudgetSubItemDocumentMapping = React.lazy(() => import('../pages/BudgetSubItemDocumentMapping'));
const BudgetSubItemPoMapping = React.lazy(() => import('../pages/BudgetSubItemPoMapping'));
const VoucherPrePaymentMapping = React.lazy(() => import('../pages/VoucherPrePaymentMapping'));
const VoucherPrePaymentMaintenance = React.lazy(() => import('../pages/VoucherPrePaymentMaintenance'));
const VoucherContractAssetClosing = React.lazy(() => import('../pages/VoucherContractAssetClosing'));
const DailyElectricityReport = React.lazy(() => import('../pages/DailyElectricityReport'));
const ProjectReport = React.lazy(() => import('../pages/ProjectReport'));
const FormRequisitionConvert = React.lazy(() => import('../pages/FormRequisition/convert'));
const DataSync = React.lazy(() => import('../pages/DataSync'));
const DataSyncProject = React.lazy(() => import('../pages/DataSync/project'));
const CompareSetting = React.lazy(() => import('../pages/DataCompare/settingCol'));
const CompareSearch = React.lazy(() => import('../pages/DataCompare/search'));
const FormAccountsPayableConvertInvoice = React.lazy(
  () => import('../pages/FormAccountsPayable/convertInvoice')
);
const SettingFixedAssetEntryDept = React.lazy(() => import('../pages/SettingFixedAssetEntryDept'));
const SettingElectricityDetect = React.lazy(() => import('../pages/SettingElectricityDetect'));
const SettingCompanyDatabaseMapping = React.lazy(() => import('../pages/SettingCompanyDatabaseMapping'));
const InvoiceIssuance = React.lazy(() => import('../pages/InvoiceIssuance'));
const InvoiceQuery = React.lazy(() => import('../pages/InvoiceQuery'));
const SettingCalander = React.lazy(() => import('../pages/SettingCalander'));
const BillCloseAccount = React.lazy(() => import('../pages/BillCloseAccount'));
const CheckoutUpdates = React.lazy(() => import('../pages/CheckoutUpdates'));
const MaintenancePaymentForSPV = React.lazy(() => import('../pages/MaintenancePaymentForSPV'));
const QueryDeptPurchaseStats = React.lazy(() => import('../pages/QueryDeptPurchaseStats'));
const PrepaidUnpaid = React.lazy(() => import('../pages/PrepaidUnpaid'));
const AccountDeactivation = React.lazy(() => import('../pages/AccountDeactivation'));
const ContactSettings = React.lazy(() => import('../pages/ContactSettings'));
const AquacultureCostIncomeReport = React.lazy(() => import('../pages/AquacultureCostIncomeReport'));
const PaymentStatusQuery = React.lazy(() => import('../pages/PaymentStatusQuery'));
const ElectricityBillReview = React.lazy(() => import('../pages/ElectricityBillReview'));
//路由
export const RouteItems = [
  { path: '/budgetAnalysisReport', element: <BudgetAnalysisReport />, breadcrumbName: '預算分析報表' },
  { path: '/budgetDetailReport', element: <BudgetDetailReport />, breadcrumbName: '預算明細報表' },
  {
    path: '/budgetSubItemMaintenance',
    element: <BudgetSubItemMaintenance />,
    breadcrumbName: '預算子項目維護',
  },
  {
    path: '/budgetSubItemDocumentMapping',
    element: <BudgetSubItemDocumentMapping />,
    breadcrumbName: '預算子項目文件對應',
  },
  {
    path: '/budgetSubItemPoMapping',
    element: <BudgetSubItemPoMapping />,
    breadcrumbName: '預算子項目PO對應',
  },
  {
    path: '/voucherPrePaymentMapping',
    element: <VoucherPrePaymentMapping />,
    breadcrumbName: '代付款傳票性質對應',
  },
  {
    path: '/voucherPrePaymentMaintenance',
    element: <VoucherPrePaymentMaintenance />,
    breadcrumbName: '代付款性質維護',
  },
  {
    path: '/voucherContractAssetClosing',
    element: <VoucherContractAssetClosing />,
    breadcrumbName: '合約資產傳票產生',
  },
  { path: '/dailyElectricityReport', element: <DailyElectricityReport />, breadcrumbName: '每日發電量報表' },
  {
    path: '/electricityBillReview',
    element: <ElectricityBillReview />,
    breadcrumbName: '電費單辨識及確認作業',
  },
  { path: '/projectReport', element: <ProjectReport />, breadcrumbName: '專案代號查詢' },
  {
    path: '/formRequisitionConvert',
    element: <FormRequisitionConvert />,
    breadcrumbName: '一般請購項目轉固定請購單',
  },
  {
    path: '/dataSync/:type',
    element: <DataSync />,
    breadcrumbName: '總公司客戶資料同步子公司',
  },
  {
    path: '/dataSync/:type',
    element: <DataSync />,
    breadcrumbName: '總公司供應商資料同步子公司',
  },
  {
    path: '/dataSyncProject',
    element: <DataSyncProject />,
    breadcrumbName: '專案代碼同步作業',
  },
  {
    path: '/dataCompareSettingCol/:type',
    element: <CompareSetting />,
    breadcrumbName: '基本資料同步檢核設定',
  },
  {
    path: '/dataCompareSearch/:type',
    element: <CompareSearch />,
    breadcrumbName: '基本資料同步查詢與匯出',
  },
  {
    path: '/formAccountsPayableConvertInvoice',
    element: <FormAccountsPayableConvertInvoice />,
    breadcrumbName: '代付請款單轉結帳單',
  },
  {
    path: '/settingFixedAssetEntryDept',
    element: <SettingFixedAssetEntryDept />,
    breadcrumbName: '固定資產分錄底稿更新部門代號資料維護',
  },
  {
    path: '/settingCompanyDatabaseMapping',
    element: <SettingCompanyDatabaseMapping />,
    breadcrumbName: '公司資料庫對應客戶代號之對照維護',
  },
  {
    path: '/settingElectricityDetect',
    element: <SettingElectricityDetect />,
    breadcrumbName: '電費單自動辨識設定',
  },
  {
    path: '/invoiceIssuance',
    element: <InvoiceIssuance />,
    breadcrumbName: '發票開立',
  },
  {
    path: '/invoiceQuery',
    element: <InvoiceQuery />,
    breadcrumbName: '發票查詢',
  },
  {
    path: '/settingCalander',
    element: <SettingCalander />,
    breadcrumbName: 'ERP 行事曆同步',
  },
  {
    path: '/billCloseAccount',
    element: <BillCloseAccount />,
    breadcrumbName: '電站帳務關帳',
  },
  {
    path: '/checkoutUpdates',
    element: <CheckoutUpdates />,
    breadcrumbName: '結帳單更新',
  },
  {
    path: '/maintenancePaymentForSPV',
    element: <MaintenancePaymentForSPV />,
    breadcrumbName: 'SPV維運費用請款',
  },
  {
    path: '/queryDeptPurchaseStats',
    element: <QueryDeptPurchaseStats />,
    breadcrumbName: '各部門採購金額統計查詢',
  },
  {
    path: '/prepaidUnpaid',
    element: <PrepaidUnpaid />,
    breadcrumbName: '預付未付查詢',
  },
  {
    path: '/accountDeactivation',
    element: <AccountDeactivation />,
    breadcrumbName: '帳號註銷單',
  },
  {
    path: '/contactSettings',
    element: <ContactSettings />,
    breadcrumbName: '聯絡人設定',
  },
  {
    path: '/aquacultureCostIncomeReport',
    element: <AquacultureCostIncomeReport />,
    breadcrumbName: '養殖成本收入明細報表',
  },
  {
    path: '/paymentStatusQuery',
    element: <PaymentStatusQuery />,
    breadcrumbName: '付款狀態查詢',
  },
];
